<script setup lang="ts">
import { computed } from 'vue';
import type { ItemRow } from '../types';

const props = defineProps<{ item: ItemRow }>();

// Размер тайла в спрайт-атласе. Само изображение 32x32, но мы хотим
// рисовать ×2 на мобильных экранах — поэтому background-size 2048×… (по
// расширению атласа ниже). Шаг — TILE_RENDER.
const TILE = 32;
const TILE_RENDER = 64;

const bg = computed(() => {
  // background-position относительно RENDERED размера.
  const x = -props.item.sprite_x * TILE_RENDER;
  const y = -props.item.sprite_y * TILE_RENDER;
  return {
    backgroundPosition: `${x}px ${y}px`,
    backgroundSize: `${32 * TILE_RENDER}px auto`,    // атлас 32 тайла шириной
    width: `${TILE_RENDER}px`,
    height: `${TILE_RENDER}px`,
  };
});

const qualityColor = computed(() => {
  switch (props.item.quality) {
    case 0: return 'bg-stone-700';
    case 1: return 'bg-blue-700';
    case 2: return 'bg-green-700';
    case 3: return 'bg-yellow-600';
    case 4: return 'bg-purple-700';
    default: return 'bg-stone-800';
  }
});
</script>

<template>
  <button
    class="group relative flex flex-col items-center gap-1 rounded-md bg-bg-card p-1 active:bg-bg-elev transition-colors"
    :title="item.name_ru ?? item.name_en"
  >
    <div class="sprite-atlas rounded-sm" :style="bg" />
    <span
      v-if="item.quality !== null"
      class="absolute top-0.5 right-0.5 inline-flex h-3 min-w-3 items-center justify-center rounded-sm px-1 text-[9px] font-bold text-white"
      :class="qualityColor"
    >{{ item.quality }}</span>
    <span class="line-clamp-2 w-full text-center text-[10px] leading-tight text-stone-300">
      {{ item.name_ru ?? item.name_en }}
    </span>
  </button>
</template>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
